var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.90186 1.66667C6.23881 1.66667 5.60293 1.93006 5.13409 2.3989C4.66525 2.86775 4.40186 3.50363 4.40186 4.16667V15.8333C4.40186 16.4964 4.66525 17.1323 5.13409 17.6011C5.60293 18.0699 6.23881 18.3333 6.90186 18.3333H13.5685C14.2316 18.3333 14.8674 18.0699 15.3363 17.6011C15.8051 17.1323 16.0685 16.4964 16.0685 15.8333V4.16667C16.0685 3.50363 15.8051 2.86775 15.3363 2.3989C14.8674 1.93006 14.2316 1.66667 13.5685 1.66667H6.90186ZM6.90186 3.33334H13.5685C13.7895 3.33334 14.0015 3.42114 14.1578 3.57742C14.3141 3.7337 14.4019 3.94566 14.4019 4.16667V15.8333C14.4019 16.0544 14.3141 16.2663 14.1578 16.4226C14.0015 16.5789 13.7895 16.6667 13.5685 16.6667H6.90186C6.68084 16.6667 6.46888 16.5789 6.3126 16.4226C6.15632 16.2663 6.06852 16.0544 6.06852 15.8333V4.16667C6.06852 3.94566 6.15632 3.7337 6.3126 3.57742C6.46888 3.42114 6.68084 3.33334 6.90186 3.33334Z",
    fill: "#0577FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0641 14.1667C11.0641 14.3877 10.9763 14.5996 10.82 14.7559C10.6638 14.9122 10.4518 15 10.2308 15C10.0098 15 9.79782 14.9122 9.64154 14.7559C9.48526 14.5996 9.39746 14.3877 9.39746 14.1667C9.39746 13.9457 9.48526 13.7337 9.64154 13.5774C9.79782 13.4211 10.0098 13.3333 10.2308 13.3333C10.4518 13.3333 10.6638 13.4211 10.82 13.5774C10.9763 13.7337 11.0641 13.9457 11.0641 14.1667Z",
    fill: "#FDDA2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.85cc997127c9fb89fb8513acb439376e.svg";
export { ForwardRef as ReactComponent };